import { useState, useEffect } from 'react';
import { getTimeUntilNextDay, formatCountdown } from '../utils/countdown';

/**
 * Hook to get a live countdown until the next day
 * Updates every second
 * @returns {string} Formatted countdown string like "5h 23m 45s"
 */
export function useCountdown() {
  const [countdown, setCountdown] = useState(() => formatCountdown(getTimeUntilNextDay()));

  useEffect(() => {
    // Update immediately
    setCountdown(formatCountdown(getTimeUntilNextDay()));

    // Update every second
    const interval = setInterval(() => {
      setCountdown(formatCountdown(getTimeUntilNextDay()));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return countdown;
}
